import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const footer = () => {

  document.fonts.ready.then(() => {
    setTimeout(() => {
      const footer = document.querySelector('.footer')
      const inner = document.querySelector('.footer__inner')
  
      if (window.innerWidth <= 650) return
  
      gsap.fromTo(inner, {
        yPercent: -50,
        scale: 1.1
      }, {
        scrollTrigger: {
          trigger: footer,
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: true,
        },
        yPercent: 0,
        scale: 1
      })
    }, 500)
  })
    
}

export default () => { }